import { datePickerLocale, FORMATO_DATA } from './date-period-picker-config'

const MASCARA_DATA_UNICA = '##/##/####'

export function aplicaMascara(valor) {
  const apenasNumeros = (valor || '').replace(/\D/g, '')
  const mascara = MASCARA_DATA_UNICA
  let resultado = ''
  let indiceNumero = 0

  if (apenasNumeros.length === 0) return ''

  for (let i = 0; i < mascara.length; i++) {
    if (mascara[i] === '#') {
      if (indiceNumero >= apenasNumeros.length) break
      resultado += apenasNumeros[indiceNumero++]
    } else {
      if (indiceNumero < apenasNumeros.length) {
        resultado += mascara[i]
      }
    }
  }

  return resultado
}

export function inicializaDateSinglePickers() {
  if (typeof $ === 'undefined' || typeof moment === 'undefined') {
    console.warn('[DateSinglePicker] jQuery ou moment.js nao disponivel. Inicializacao ignorada.')
    return
  }

  if (typeof $.fn.daterangepicker === 'undefined') {
    console.warn('[DateSinglePicker] Plugin daterangepicker nao disponivel. Inicializacao ignorada.')
    return
  }

  const inputs = document.querySelectorAll('[data-date-single-picker]')

  inputs.forEach((input) => {
    if (input.dataset.dspInitialized === 'true') return
    if (input.disabled || input.readOnly) return

    $(input).daterangepicker({
      singleDatePicker: true,
      autoApply: true,
      showDropdowns: true,
      autoUpdateInput: false,
      locale: {
        ...datePickerLocale,
        format: FORMATO_DATA,
      },
    })

    $(input).on('apply.daterangepicker', (_evento, picker) => {
      input.value = picker.startDate.format(FORMATO_DATA)
    })

    input.addEventListener('input', (evento) => {
      const valorMascarado = aplicaMascara(evento.target.value)
      evento.target.value = valorMascarado
    })

    input.addEventListener('blur', () => {
      if (input.value === '') {
        const picker = $(input).data('daterangepicker')
        if (picker) {
          picker.setStartDate(moment())
          picker.setEndDate(moment())
        }
        return
      }

      if (input.value.length < 10 || !moment(input.value, FORMATO_DATA, true).isValid()) {
        input.value = ''
      }
    })

    input.dataset.dspInitialized = 'true'
  })
}

document.addEventListener('DOMContentLoaded', inicializaDateSinglePickers)
document.addEventListener('turbo:load', inicializaDateSinglePickers)
